// Product carousel: prev/next buttons (custom --carousel-prev / --carousel-next commands) page the
// scroll-snap track; buttons are aria-disabled at either end.
class SCarousel extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    const track = this.querySelector('[data-carousel-track]');
    if (!track) return;

    this.addEventListener('command', (event) => {
      if (event.command !== '--carousel-prev' && event.command !== '--carousel-next') return;
      const direction = event.command === '--carousel-next' ? 1 : -1;
      const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * rtl * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
    }, { signal });

    const update = () => this.#updateButtons(track);
    track.addEventListener('scroll', update, { passive: true, signal });
    window.addEventListener('resize', update, { signal });
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #updateButtons(track) {
    const max = track.scrollWidth - track.clientWidth;
    const position = Math.abs(track.scrollLeft);
    const prev = this.querySelector('[command="--carousel-prev"]');
    const next = this.querySelector('[command="--carousel-next"]');
    prev?.setAttribute('aria-disabled', String(position <= 2));
    next?.setAttribute('aria-disabled', String(position >= max - 2));
  }
}

if (!customElements.get('s-carousel')) {
  customElements.define('s-carousel', SCarousel);
}
